import React from 'react'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import classNames from 'classnames'
import styles from '../FormFieldStyles.module.scss'
import Error from '../Error'
import { setLoginError } from '../../../store/auth/actions'
import { useDispatch } from 'react-redux'

interface InputFieldProps {
  type: string
  name: string
  label?: string
  placeholder: string
  required?: boolean
  autoFocus?: boolean
  labelHidden?: boolean
  component?: any
  // component?: string;
  disabled?: boolean
  setText?: (value: string) => void
  options?: any
  step?: number
  value?: any
  onChange?: (e: any) => void
}

const InputField: React.FC<InputFieldProps> = ({
  type,
  name,
  label,
  placeholder,
  required = false,
  autoFocus = false,
  labelHidden = false,
  component = 'input',
  disabled = false,
  setText = () => {},
  options,
  step = 0.1,
  value,
  onChange,
}) => {
  const formik = useFormikContext()
  const inputClasses = classNames(styles.input)
  const inputFieldClasses = classNames(styles.field)
  const dispatch = useDispatch()

  const handleChange = (value: React.ChangeEvent<HTMLInputElement>) => {
    setText(value.target.value.replace(/^\s+/, ''))
    dispatch(setLoginError(null))
    formik.setFieldValue(name, value.target.value.replace(/^\s+/, ''))
  }

  return (
    <div className={inputFieldClasses}>
      {!labelHidden && (
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      )}
      <Field
        type={type}
        placeholder={placeholder}
        name={name}
        required={required}
        autoFocus={autoFocus}
        className={inputClasses}
        component={component}
        disabled={disabled}
        onChange={handleChange}
        step={step}
        options={options}
      />
      <Error>
        <ErrorMessage name={name}>
          {(msg) => {
            return <span className={styles.errorMsg}>{msg}</span>
          }}
        </ErrorMessage>
      </Error>
    </div>
  )
}

export default InputField
